export default "__VITE_ASSET__BPInwZ5D__"